import {
  CONFIRM_PAYMENT,
  NEW_PAYMENTS,
  NEW_PAYMENT,
  NEW_SINGLE_PAYMENT,
  NEW_PAYMENTS_FILTERS,
  NEW_LOADING_TABLE,
  NEW_SEARCHING

} from '../actions/paymentActions';

import {
  RESET_ACCOUNT,
  LOG_OUT

} from '../actions/accountActions';

const initialState = {
  confirm       : null,
  page          : null,
  payment       : null,
  activeFilters : [{
    label: 'Fecha pagos',
    filterKey: 'paid_at',
    type: 'date',
    filterCondition: 'btw',
    value: '',
    period: 'Todo'
  },{
    label: 'Buscar',
    filterKey: 'general',
    type: 'search',
    value: '',
    personalized: true
  },{
    label: 'Página',
    filterKey: 'page',
    type: 'page',
    value: 1,
    personalized: true
  },{
    label: 'Tabs',
    filterKey: 'status',
    type: 'tab',
    value: '', // => 'Todos'
    activeTab: '1',
    personalized: true
  },{
    label: 'Estado',
    filterKey: 'status',
    type:'options',
    options: [
      { label: 'Aceptados', value: 'confirmed' },
      { label: 'Cancelados', value: 'cancel'},
    ],
    value: 'confirmed,cancel',
    personalized: true
  }],
  updateTable: true,
  searching: false,
  loadingTable: false

} // END initialState


export default function (state = initialState, action) {
  let { payload } = action, newState;
  switch (action.type) {
    case CONFIRM_PAYMENT:
      newState = { confirm: payload };
      return { ...state, ...newState };

    case NEW_PAYMENTS:
      newState = { page: payload };
      return { ...state, ...newState };

    case NEW_PAYMENT:
      newState = { payment: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_PAYMENT:
      newState = { payment: payload };
      return { ...state, ...newState };

    case NEW_PAYMENTS_FILTERS:
      newState = { activeFilters: payload.filters , updateTable: payload.updateTable, searching: payload.searching }
      return { ...state, ...newState };

    case NEW_LOADING_TABLE:
      newState = { loadingTable: payload }
      return { ...state, ...newState };

    case NEW_SEARCHING:
      newState = { searching: payload };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState }
      return { ...state, ...initialState };

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/paymentReducer.js